module.exports = __webpack_public_path__ + "officialStatic/img/circle2.22fda6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/test/circle2.png
// module id = rfk/
// module chunks = 0